export default "__VITE_ASSET__Bk858a3n__"